import React from 'react';
import { message } from 'antd';
import common from '@/asserts/js/common';
import ApplyComponents from '@/components/App/ApplyComponents';
import RiskComponents from '@/components/modal/risk/index';
import OnlineComponents from '@/components/modal/online/index';
import AgreeComponents from '@/components/modal/agree/index';
import AgreeNoticeComponents from '@/components/modal/agreeNotice/index';
import styles from './Login/index.less';

class NotFoundIndex extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      uid:'',
      aid:'',
      isApplyShow:false,
      riskVisible:false,
      onlineVisible:false,
      agreeVisible:false,
      agreeNoticeVisible:false,
    }
  }
  //登录---这个页面是给客户在网址输入对应的参数进行登录的，免除登录页面 
  loginFun(txid,data){
    fetch(common.getHttpZs+'access',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({txid:txid,data:data})
    })
    .then(res1 => res1.json())
    .then(res1 => {
      //本地存储token/uid
      if(res1['status']==0){
        sessionStorage.setItem('token',res1['data']['token'])
        sessionStorage.setItem('loginName','notFound')

        //WebCA
        if (common.enableWebca && !window.inAppDetector.isInApp()) {
          const memberid = res1['data']['uid'];
          const filter = "//S_CN=" + memberid + "//"; //憑證挑選條件
          window.WebCAQueryCertState(memberid, filter, (code, msg, token, data) => {
            if (code === 0 && data) {
              let d = JSON.parse(data);
              let rafunc = d.suggestAction;
              
              if (rafunc !== "None") { // Need to apply/renew cert
                const webcaInfoRequestOptions = {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json'},
                  body: JSON.stringify({ token: res1['data']['token'], rafunc: rafunc })
                };
                
                //Get parameters for calling WebCAInvoke
                fetch(common.getHttp + 'getwebcainfo', webcaInfoRequestOptions)
                .then(response => response.json())
                .then(data => {
                  if (data.status === 0) {
                    data = data.data;
                    // window.setWebCAinWebview(true);
                    window.setWebCAinWebview(window.inAppDetector.isInApp()); //確認執行環境是否在WebView
                    //呼叫WebCA執行對應raFunc的憑證作業
                    window.WebCAInvoke(data.BusinessNo, data.APIVersion, data.HashKeyNo, data.VerifyNo, data.ReturnParams, memberid, rafunc, data.IdentifyNo, process.env.PUBLIC_URL + "/WebCA/webcaFrm.html", common.getHttpWebca, (code, msg, token, data) => {
                      if (code===0 || code==="0000" || code===7000) {
                        this.accountDataFun(res1['data'])
                      } else {
                        this.setState({
                          isLoading: false
                        })
                        message.warning({
                          content: code + " " + msg
                        })
                      }
                    });
                  } else {
                    this.setState({
                      isLoading: false
                    })
                    message.warning({
                      content: data.message
                    })
                  }
                })
              } else {
                this.accountDataFun(res1['data'])
              }
            } else {
              this.setState({
                isLoading: false
              })
              message.warning({
                content: code + " " + msg
              })
            }
          });
        } else {
          this.accountDataFun(res1['data'])
        }
      } else {
        //获取失败
        this.setState({
          isLoading: false
        })
        if(res1['status']==1001) {
          message.warning({
            content: "即將上線，敬請期待!!"
          })
        } else {
          message.warning({
            content: res1['error']?(res1['error']['Code'] + " " + res1['error']['Msg']):res1['message']
          })
        }
      }
    })
  }
  //登录---这个页面是给客户用POST输入对应的参数进行登录的，免除登录页面 
  loginFun2(token,uid,aid){
        //WebCA
        if (common.enableWebca && !window.inAppDetector.isInApp()) {
          const memberid = uid;
          const filter = "//S_CN=" + memberid + "//"; //憑證挑選條件
          window.WebCAQueryCertState(memberid, filter, (code, msg, t, data) => {
            if (code === 0 && data) {
              let d = JSON.parse(data);
              let rafunc = d.suggestAction;
              
              if (rafunc !== "None") { // Need to apply/renew cert
                const webcaInfoRequestOptions = {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json'},
                  body: JSON.stringify({ token: token, rafunc: rafunc })
                };
                
                //Get parameters for calling WebCAInvoke
                fetch(common.getHttp + 'getwebcainfo', webcaInfoRequestOptions)
                .then(response => response.json())
                .then(data => {
                  if (data.status === 0) {
                    data = data.data;
                    // window.setWebCAinWebview(true);
                    window.setWebCAinWebview(window.inAppDetector.isInApp()); //確認執行環境是否在WebView
                    //呼叫WebCA執行對應raFunc的憑證作業
                    window.WebCAInvoke(data.BusinessNo, data.APIVersion, data.HashKeyNo, data.VerifyNo, data.ReturnParams, memberid, rafunc, data.IdentifyNo, process.env.PUBLIC_URL + "/WebCA/webcaFrm.html", common.getHttpWebca, (code, msg, token, data) => {
                      if (code===0 || code==="0000" || code===7000) {
                        this.accountDataFun({token, uid, aid})
                      } else {
                        this.setState({
                          isLoading: false
                        })
                        message.warning({
                          content: code + " " + msg
                        })
                      }
                    });
                  } else {
                    this.setState({
                      isLoading: false
                    })
                    message.warning({
                      content: data.message
                    })
                  }
                })
              } else {
                this.accountDataFun({token, uid, aid})
              }
            } else {
              this.setState({
                isLoading: false
              })
              message.warning({
                content: code + " " + msg
              })
            }
          });
        } else {
          this.accountDataFun({token, uid, aid})
        }
  }
  //判断是否需要进入免责声明页面
  checkeagreementFun(item, aidListData){
    let uid=item['uid'];
    let aid=item['aid'];

    this.setState({
      uid,
      aid
    });

    fetch(common.getHttpAgree+'checkeagreement',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:item['token']
      })
    })
    .then(res => res.json())
    .then(res => {
      if(res['status']==0){
        //已填写申请，则显示所有的页面
        if(res['data']['signed']){
          this.riskNoticeFun(aid, uid, aidListData);
          return
        }
        //未填写申请，则显示免责声明页面
        this.setState({
          isApplyShow:true,
          isLoading:false,
        })
      }
    })
  }
  // 登入後檢查是否簽署
  riskNoticeFun(aid, uid, aidListData){
    fetch(common.getHttpZs+'getSignRiskNotice',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:sessionStorage.getItem('token'),
        source_type:'0015',
      })
    })
    .then(res1 => res1.json())
    .then(res1 => {
      if(res1['status']==0){
        // sign_status: [0]已签署，[1]未签署，[10]签署中
        let sign_status=res1['data']['sign_status'];
        if(sign_status==1){
          this.setState({
            riskVisible:true,
          });
        }else{
          this.gotoMainPage(aid, uid, aidListData);
        }
      } else {
        //获取失败
        this.setState({
          isLoading: false,
        });
        message.warning({
          content: res1['message'],
        });
      }
    });
  }
  // 簽署複委託風險預告書
  cbRiskDataFun(btn){
    const {aid, uid, aidListData} = this.state;
    this.setState({
      riskVisible:false
    });

    if(btn==='Y'){
      this.setState({
        onlineVisible:true
      });
    }else{
      this.gotoMainPage(aid, uid, aidListData);
    }
  }
  // 線上簽署
  cbOnlineDataFun(btn,isSwitchAccount){
    this.setState({
      onlineVisible:false
    });

    if(btn==='Y'){
      this.setState({
        agreeVisible:true
      });
    }else{
      this.setState({
        riskVisible:true
      });
    }
  }
  // 是否同意簽署
  cbAgreeDataFun(btn){
    if(btn==='Y'){
      this.setState({
        agreeNoticeVisible:true,
        agreeVisible:false
      });
    }else{
      this.setState({
        onlineVisible:true,
        agreeVisible:false,
      });
    }
  }
  // 已簽署--登录
  cbAgreeNoticeDataFun(sign){
    const {aid, uid, aidListData} = this.state;
    this.setState({
      agreeNoticeVisible:false,
    });

    if(sign === 'open'){
      this.setState({
        riskVisible:true
      });
    }else{
      this.gotoMainPage(aid, uid, aidListData);
    }
  }
  // 获取账号列表
  accountDataFun(resData){
    fetch(common.getHttpZs+'getAccountIdList',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:sessionStorage.getItem('token')
      })
    })
    .then(res => res.json())
    .then(res => {
      //获取数据成功
      if(res['status']==0){
        const data=res['data']['aid_obj_list'];

        sessionStorage.setItem('aidListData',JSON.stringify(data));

        this.setState({
          aidListData:data
        });

        this.checkeagreementFun(resData, data);
      }else{
        this.setState({
          isLoading:false
        });
      }
    })
  }
  // 进入到主页
  gotoMainPage(aid, uid, aidListData){
    const {locationName}=this.props;

    this.props.callbackUid(uid);

    sessionStorage.setItem('uid', uid);
    sessionStorage.setItem('aidListId', aid);

    const aidDataLen=Object.keys(aidListData);
    const isLen=aidDataLen.length>1?'Y':'N';

    sessionStorage.setItem('aidListData',JSON.stringify(aidListData));
    sessionStorage.setItem('isSwitchShow',isLen);
    sessionStorage.setItem('isSwitchFirstShow',isLen);
    sessionStorage.setItem('isLoginOnload','Y');
    sessionStorage.setItem('firstPopup', 'Y');

    this.props.callbackpathname('/'+locationName[1]+'/Quote');

    this.setState({
      isApplyShow:null,
      isLoading:false,
    });
  };
  componentDidMount(){
    let uid = sessionStorage.getItem('uid')
    let token = sessionStorage.getItem('token')
    let aid = sessionStorage.getItem('aidListId')
    let target = sessionStorage.getItem('target')
    let lang=localStorage.getItem('lang')
    let theme=localStorage.getItem('theme')
    sessionStorage.clear() //清空存储数据
    localStorage.setItem('lang',lang?lang:'zh-CN')
    localStorage.setItem('theme',theme?theme:'Dark')

    if (uid!=null && token!=null && aid!=null) {
      sessionStorage.setItem('token', token)
      sessionStorage.setItem('loginName','notFound')
      if(target!==null){
        sessionStorage.setItem('target',target)
        sessionStorage.setItem('navId',target=='trade'?'trade':'quote')
      }
      this.loginFun2(token,uid,aid)
    }
    //在地址栏输入对应的参数进行登录，免登录页面
    let txid=common.getUrlSearch('txid')
    let data=common.getUrlSearch('data')
    if((!txid && typeof(txid)!='undefined' && txid!=0)||(!data && typeof(data)!='undefined' && data!=0)||txid==''||data=='') return
    txid = decodeURIComponent(txid)
    data = decodeURIComponent(data)
    this.loginFun(txid,data)
  }
  render() {
    const {isApplyShow,uid,aid,riskVisible,agreeVisible,agreeNoticeVisible,onlineVisible,aidListData}=this.state
    return (
      <div className={isApplyShow?'':styles.notFound}>
        {
          //免责声明页面
          isApplyShow?
          <ApplyComponents 
            {...this.props}
            uid={uid}
            aid={aid}
            callbackpathname={()=>{
              this.riskNoticeFun(aid, uid, aidListData);
            }}
          />
        :
          <span style={{display:isApplyShow?'none':''}}></span>
        }
        {riskVisible &&
          <RiskComponents 
            {...this.props}
            visible={riskVisible}
            cbBtnDataFun={(sign)=>this.cbRiskDataFun(sign)}
          />
        }
        {onlineVisible &&
          <OnlineComponents 
            {...this.props} 
            aid={aid}
            uid={uid}
            visible={onlineVisible}
            aidListData={aidListData}
            cbBtnDataFun={(sign, isSwitchAccount)=>this.cbOnlineDataFun(sign, isSwitchAccount)}
            cbUpageAid={(value)=>{
              this.setState({
                aid: value
              });
            }}
          />
        }
        {agreeVisible &&
          <AgreeComponents 
            {...this.props} 
            aid={aid}
            uid={uid}
            visible={agreeVisible}
            cbBtnDataFun={(sign)=>this.cbAgreeDataFun(sign)}
          />
        }
        {agreeNoticeVisible &&
          <AgreeNoticeComponents 
            {...this.props}  
            aid={aid}
            uid={uid}
            visible={agreeNoticeVisible}
            cbBtnDataFun={(sign)=>this.cbAgreeNoticeDataFun(sign)}
          />
        }
      </div>
    )
  }
}
export default NotFoundIndex;